import { LabMDM } from "./lab";
import { MachineType } from "./machineType";

//This model is used to define th elab machine properties
export class Machine {
    id: string;
	/** The machine name. */
	name :string ;
    
    /** The ip address of the physical machine. */
    hostAddress:string;
	
    /** The lab where the machine is located. */
    lab:LabMDM;
    
     /** The machine barcode. */
    barcode: string ;

    active:boolean;
    
    type: MachineType;

    subType: string;

    fileType: string;

    manufacturer: string;

}